import { apiPost } from '@ibkr/clientportal.common/src/api/default'

import { PortalBaseUrl } from '@ibkr/clientportal.common/src/js/portalBaseUrl.js'

const base = '';

function report(message) {
    // disabled for now CLNTPORTAL-1065
    // return apiPost(base + '/one/error/log', { 'message': message });
    return new Promise();
}

export default {
    report
}
